import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import GochiMenuTableHead from '../../components/molecules/GochiMenuTableHead';
import GochiMenuTableBody from '../../components/molecules/GochiMenuTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import GochiMenuDetail from './GochiMenuDetail';
import GochiMenuEdit from './GochiMenuEdit';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ShowHideDialog from '../../components/molecules/ConfirmDialog';
import DeleteMenuEventDialog from '../../components/molecules/DeleteMenuEventDialog';
import {
  getGochiMenus,
  getGochiMenuDetail,
  deleteGochiMenu,
  showHideGochiMenu,
  changeShashokuOption,
  addMenuEvent,
  deleteMenuEvent
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import ContentDialog from '../../components/molecules/ContentDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.menus,
      totalCount: state.gochiMenus.totalCount,
      offset: state.gochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getGochiMenuDetail,
          deleteGochiMenu,
          showHideGochiMenu,
          changeShashokuOption,
          addMenuEvent,
          deleteMenuEvent
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('deleteNote', 'setDeleteNote', ''),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('openShowHide', 'updateOpenShowHide', false),
  withState('showHideNote', 'setShowHideNote', ''),
  withState('showHide', 'setShowHide', 1),
  withState('openDeleteMenuEvent', 'updateOpenDeleteMenuEvent', false),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('message', 'setMessage', ''),
  withState('detail', 'setDetail', {}),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    progress,
    searchKey,
    page,
    selectedPage,
    handleChangePage,
    menus,
    totalCount,
    offset,
    name,
    openDetailModal,
    updateOpenDetailModal,
    openDelete,
    updateOpenDelete,
    deleteNote,
    setDeleteNote,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    openEdit,
    updateOpenEdit,
    openEditConfirm,
    updateOpenEditConfirm,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    updateIsDeleteSuccess,
    resultMessage,
    setResultMessage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    openShowHide,
    updateOpenShowHide,
    showHideNote,
    setShowHideNote,
    showHide,
    setShowHide,
    openDeleteMenuEvent,
    updateOpenDeleteMenuEvent,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    setFullMessage,
    message,
    setMessage,
    detail,
    setDetail,
    menuGenre,
    menuSituation,
    menuUserTarget
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const paramShowHide = {
      showHide
    };
    const getGochiMenu = async id => {
      await actions.getGochiMenuDetail(id).then(detailData => {
        checkSession(detailData);
        const dataDetail = _.cloneDeep(detailData.payload);
        if (detailData.payload.reducedTaxType === 'REDUCED') {
          dataDetail.reducedTaxCheck = true;
          dataDetail.reducedTaxTypeStr = '対象';
        } else {
          dataDetail.reducedTaxCheck = false;
          dataDetail.reducedTaxTypeStr = '対象外';
        }
        dataDetail.tagStr = detailData.payload.tags
          .map(tag => {
            return `${tag.tagName}`;
          })
          .join(' ');

        if (detailData.payload.menuGenreId) {
          dataDetail.menuGenreName = menuGenre.find(
            genre =>
              genre.menuGenreId.toString() ===
              detailData.payload.menuGenreId.toString()
          ).menuGenreName;
          dataDetail.menuGenreId = detailData.payload.menuGenreId;
        } else {
          dataDetail.menuGenreName = '';
          dataDetail.menuGenreI = null;
        }

        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const situationNames = [];
          detailData.payload.menuSituationIds.forEach(situationId => {
            const situationName = menuSituation.find(
              situation =>
                situation.menuSituationId.toString() === situationId.toString()
            ).menuSituationName;
            situationNames.push(situationName);
          });
          dataDetail.menuSituationIds = detailData.payload.menuSituationIds;
          dataDetail.menuSituationNames = situationNames.join(', ');
        } else {
          dataDetail.menuSituationIds = [];
          dataDetail.menuSituationNames = '';
        }

        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuUserTargetIds.length
        ) {
          const userTargetNames = [];
          detailData.payload.menuUserTargetIds.forEach(userTargetId => {
            const userTargetname = menuUserTarget.find(
              userTarget =>
                userTarget.menuUserTargetId.toString() ===
                userTargetId.toString()
            ).name;
            userTargetNames.push(userTargetname);
          });
          dataDetail.menuUserTargetIds = detailData.payload.menuUserTargetIds;
          dataDetail.menuUserTargetNames = userTargetNames.join(', ');
        } else {
          dataDetail.menuUserTargetIds = [];
          dataDetail.menuUserTargetNames = '';
        }
        if (detailData.payload.subscription) {
          dataDetail.subscription = detailData.payload.subscription;
          dataDetail.subscriptionInterval =
            detailData.payload.subscriptionInterval;
          dataDetail.subscriptionIntervalCount =
            detailData.payload.subscriptionIntervalCount;
        }
        setDetail(dataDetail);
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiMenu(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = id => {
      let readonly = false;
      menus
        .filter(item => item.menuId === id)
        .forEach(menu => {
          if (menu.readonly) {
            readonly = true;
          }
        });
      if (readonly) {
        const msg =
          'このメニューは未使用の「ごち」が残っているため、編集できません。';
        setFullMessage(msg);
        updateOpenFullMessage(true);
      } else {
        progress.updateLoading(true);
        progress.updateOpenProgress(true);
        getGochiMenu(id)
          .then(() => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            updateOpenEdit(true);
          })
          .catch(() => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      }
    };
    const deleteOpenAction = id => {
      let readonly = false;
      let note = '';
      menus
        .filter(item => item.menuId === id)
        .forEach(menu => {
          if (menu.readonly) {
            readonly = true;
          }
          if (menu.gochiKidFlag === 1) {
            note = '※当メニューは、こどもごちめし利用対象メニューです。';
          }
        });
      if (readonly) {
        const msg =
          'このメニューは未使用の「ごち」が残っているため、削除できません。\nメニューとして表示したくない場合は「非表示」を選択ください。';
        setFullMessage(msg);
        updateOpenFullMessage(true);
      } else {
        updateOpenDelete(true);
        setTargetRowId(id);
        setDeleteNote(note);
      }
    };
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedMenu = await actions
        .deleteGochiMenu(targetRowId)
        .then(data => checkSession(data));
      if (deletedMenu.type === 'DELETE_GOCHI_MENU_SUCCESS') {
        updateIsDeleteSuccess(true);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('削除に失敗しました。');
        updateLoading(false);
      }
    };

    const showHideOpenAction = params => {
      updateOpenShowHide(true);
      if (params.showHide) {
        setShowHide(0);
      } else {
        setShowHide(1);
      }
      setTargetRowId(params.id);
      const arr = [];
      if (params.gochimeshiFlag === 1) {
        arr.push('「ごちめし（さきめし含む）」');
      }
      if (params.shashokuFlag === 1) {
        arr.push('「社食ごちめし」');
      }
      if (params.gochiKidFlag === 1) {
        arr.push('「こどもごちめし」');
      }
      if (arr.length) {
        setShowHideNote(`※${arr.join('と')}で、メニューが非公開になります。`);
      } else {
        setShowHideNote('');
      }
    };
    const cancelShowHideAction = () => updateOpenShowHide(false);
    const showHideAction = async () => {
      updateLoading(true);
      const showHidedMenu = await actions
        .showHideGochiMenu(targetRowId, paramShowHide)
        .then(data => checkSession(data));
      if (showHidedMenu.type === 'SHOW_HIDE_GOCHI_MENU_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
        updateOpenShowHide(false);
      } else {
        updateLoading(false);
        updateOpenShowHide(false);
      }
    };
    const changeShashokuOptionAction = async params => {
      updateLoading(true);
      const shashokuOn = params.shashokuFlag;
      const gochimeshiOn = params.gochimeshiFlag;
      const changeResponse = await actions
        .changeShashokuOption(params.menuId, shashokuOn, gochimeshiOn)
        .then(data => checkSession(data));
      if (changeResponse.type === 'CHANGE_SHASHOKU_OPTION_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
      } else {
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    const addMenuEventAction = async params => {
      console.log('params=========', params);
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      const dataResponse = await actions
        .addMenuEvent(params)
        .then(data => checkSession(data));
      if (dataResponse.type === 'ADD_MENU_EVENT_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        progress.updateLoading(false);
        progress.updateOpenProgress(false);
      } else {
        progress.updateLoading(false);
        progress.updateOpenProgress(false);
      }
    };

    const deleteMenuEventOpenAction = id => {
      updateOpenDeleteMenuEvent(true);
      setTargetRowId(id);
    };
    const deleteMenuEventAction = async () => {
      updateLoading(true);
      const updatedMenu = await actions
        .deleteMenuEvent(targetRowId)
        .then(data => checkSession(data));
      if (updatedMenu.type === 'DELETE_MENU_EVENT_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
        updateOpenDeleteMenuEvent(false);
      } else {
        updateLoading(false);
        updateOpenDeleteMenuEvent(false);
      }
    };
    const cancelDeleteMenuEventAction = () => updateOpenDeleteMenuEvent(false);

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiMenuTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <GochiMenuTableBody
              menus={menus}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenDetailModal={updateOpenDetailModal}
              detailOpenAction={detailOpenAction}
              editOpenAction={editOpenAction}
              showHideOpenAction={showHideOpenAction}
              deleteOpenAction={deleteOpenAction}
              setTargetRowId={setTargetRowId}
              roles={roles}
              order={order}
              orderBy={orderBy}
              changeShashokuOptionAction={changeShashokuOptionAction}
              message={message}
              setMessage={setMessage}
              deleteMenuEventOpenAction={deleteMenuEventOpenAction}
              addMenuEventAction={addMenuEventAction}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={menus}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <GochiMenuDetail
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
          />
        </Modal>
        <Modal open={openEdit}>
          <GochiMenuEdit
            name={name}
            roles={roles}
            openEditConfirm={openEditConfirm}
            updateOpenEdit={updateOpenEdit}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
          />
        </Modal>
        <ShowHideDialog
          openConfirm={openShowHide}
          cancelAction={cancelShowHideAction}
          updateOpenConfirm={updateOpenShowHide}
          okAction={showHideAction}
          targetRowId={targetRowId}
          message="表示状況を変更します。よろしいでしょうか？"
          note={showHideNote}
        />
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target="メニュー"
          deleteNote={deleteNote}
        />
        <DeleteMenuEventDialog
          openDelete={openDeleteMenuEvent}
          updateOpenDelete={updateOpenDeleteMenuEvent}
          cancelAction={cancelDeleteMenuEventAction}
          deleteAction={deleteMenuEventAction}
          targetRowId={targetRowId}
          target="メニューイベント"
        />
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
